import {
  VStack,
  Flex,
  Divider,
  Box,
  Container,
  Center,
  Heading,
} from '@chakra-ui/react';
import { BPCLink } from 'common/components/BPCLink';
import BPCLogo from 'common/icons/BPCLogo';
import GoogleLoginButton from 'features/auth/components/GoogleLoginButton';
import LoginForm from 'features/auth/components/LoginForm';
import { Helmet } from 'react-helmet';
import { RoutePath } from 'router/routes.paths';

export default function LoginPage() {
  return (
    <Container maxW="md">
      <Helmet>
        <title>BPC - login</title>
      </Helmet>
      <VStack py={20} rounded="md">
        <Center>
          <BPCLogo width="50%" />
        </Center>
        <Heading pb={2}>Se connecter sur BPC</Heading>

        <GoogleLoginButton />

        <Flex width={'100%'} py={3} alignItems={'center'}>
          <Divider />
          <Box as="span" px={2}>
            ou
          </Box>
          <Divider />
        </Flex>

        <LoginForm />
        <Box>
          Pas encore de compte ?&nbsp;
          <BPCLink variant="link" to={RoutePath.signUp}>
            S'inscrire
          </BPCLink>
        </Box>
      </VStack>
    </Container>
  );
}
